import { reduxStore } from '../services/gecko-store/redux';
import GeckoRequest from '../services/gecko-request';

const dispatch = (event, payload = {}, metadata = {}) => {
  return reduxStore.dispatch({
    type: event,
    payload,
    metadata,
  });
};
export const newSavedReply = (savedReply) => {
  return { type: 'NEW_SAVED_REPLY', payload: savedReply };
};

export const newSavedReplies = (savedReplies) => {
  return { type: 'NEW_SAVED_REPLIES', payload: savedReplies };
};

export const updateSavedReply = (savedReply) => {
  return { type: 'UPDATE_SAVED_REPLY', payload: savedReply };
};

export const deleteSavedReply = (savedReply) => {
  return { type: 'DELETE_SAVED_REPLY', payload: savedReply };
};

export const pinSavedReply = async (savedReply) => {
  await GeckoRequest.post(`/saved-replies/pin/${savedReply.id}`);
  dispatch('PIN_SAVED_REPLY', savedReply);
};

export const unpinSavedReply = async (savedReply) => {
  await GeckoRequest.delete(`/saved-replies/pin/${savedReply.id}`);
  dispatch('UNPIN_SAVED_REPLY', savedReply);
};
